import { EXERCISE_LOG_SUMMARIES_ACTION } from '../../constants'
import createReduxAction from '../../../redux/actions/create'
import {
  EXERCISE_LOG_SUMMARY_CLASS_NAME,
  EXERCISE_LOG_SUMMARY_KEY
} from '../../../exercise-log-summary/model/constants'

function createExerciseLogSummaryAction (params = {}) {
  return (dispatch) => {
    return dispatch(createReduxAction({
      type: EXERCISE_LOG_SUMMARIES_ACTION.CREATE,
      payload: {
        data: {
          className: EXERCISE_LOG_SUMMARY_CLASS_NAME,
          changed: {
            [EXERCISE_LOG_SUMMARY_KEY.EXERCISE_LOGS]: [],
            [EXERCISE_LOG_SUMMARY_KEY.ONE_REP_MAX]: 0,
            ...params
          }
        }
      }
    }))
  }
}

export default createExerciseLogSummaryAction
